module.exports = __webpack_public_path__ + "img/Kanto-Ads-logo.a96667ab.svg";